
import { fromEvent, combineLatest, BehaviorSubject } from 'rxjs'
import { map, auditTime, distinctUntilChanged } from 'rxjs/operators'

const VISIBLE_CLASS = 'page--newsletter-bar-visible'

export default class NewsletterBarController {
  constructor (options) {
    this._bindUIActions()
  }

  _bindUIActions () {
    const scrollEvents$ = fromEvent(window, 'scroll')
    // scrollEvents$.subscribe(scrollY => console.log('scrollEvent', window.scrollY))
    const scrollY$ = scrollEvents$.pipe(
      map(e => {
        return window.scrollY
      }),
      auditTime(100)
    )

    const scrolled$ = scrollY$.pipe(
      map(scrollY => scrollY > 100),
      distinctUntilChanged()
    )

    const footerVisible$ = new BehaviorSubject(false)

    const footerElement = document.querySelector('.page-footer')
    if (footerElement) {
      // eslint-disable-next-line no-undef
      this.footerObserver = new IntersectionObserver(
        (entries, observer) => {
          if (entries.length > 0) {
            const footer = entries[0]
            footerVisible$.next(footer.isIntersecting)
          }
        },
        {
          root: null,
          rootMargin: '0px 0px 0px 0px',
          threshold: 0
        }
      )
      this.footerObserver.observe(footerElement)
    }

    const barShowing$ = combineLatest(scrolled$, footerVisible$).pipe(
      map(([scrolled, footerVisible]) => scrolled && !footerVisible),
      distinctUntilChanged()
    )

    barShowing$.subscribe(barShowing => {
      if (barShowing) {
        document.body.classList.add(VISIBLE_CLASS)
      } else {
        document.body.classList.remove(VISIBLE_CLASS)
      }
    })
  }
}
